import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/router'
import * as _ from 'lodash'
import VueMoment from 'vue-moment'
import Toasted from 'vue-toasted'
import Vuelidate from 'vuelidate'
import { BOverlay } from "bootstrap-vue";

Vue.use(Vuex)
Vue.use(VueMoment)
Vue.use(Toasted, { duration: 5000 })
Vue.use(Vuelidate)

import App from '@/App'

Vue.component('app', App)

import {
    NavbarPlugin,
    BreadcrumbPlugin,
    LayoutPlugin,
    CardPlugin,
    ButtonPlugin,
    FormPlugin,
    FormCheckboxPlugin,
    FormRadioPlugin,
    FormInputPlugin,
    FormTextareaPlugin,
    FormGroupPlugin,
    FormSelectPlugin,
    FormFilePlugin,
    InputGroupPlugin,
    ProgressPlugin,
    TablePlugin,
    PaginationPlugin,
    ModalPlugin,
    CollapsePlugin,
    BadgePlugin,
    AlertPlugin,
    TabsPlugin,
    PopoverPlugin,
    ListGroupPlugin,
    SpinnerPlugin,
    ButtonGroupPlugin,
    SidebarPlugin,
    IconsPlugin,
    LinkPlugin
} from 'bootstrap-vue'

Vue.use(NavbarPlugin)
Vue.use(BreadcrumbPlugin)
Vue.use(LayoutPlugin)
Vue.use(CardPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormFilePlugin)
Vue.use(InputGroupPlugin)
Vue.use(ProgressPlugin)
Vue.use(TablePlugin)
Vue.use(PaginationPlugin)
Vue.use(ModalPlugin)
Vue.use(CollapsePlugin)
Vue.use(BadgePlugin)
Vue.use(AlertPlugin)
Vue.use(TabsPlugin)
Vue.use(PopoverPlugin)
Vue.use(ListGroupPlugin)
Vue.use(AlertPlugin)
Vue.use(SpinnerPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(SidebarPlugin)
Vue.use(IconsPlugin)
Vue.use(LinkPlugin)

Vue.component('b-overlay', BOverlay)

import HighchartsVue from 'highcharts-vue'

Vue.use(HighchartsVue)
import Highcharts from 'highcharts'
import * as more from 'highcharts/highcharts-more'
import HighchartsNoData from 'highcharts/modules/no-data-to-display'

more(Highcharts)
HighchartsNoData(Highcharts)
// bullet(Highcharts)

import VuePluralize from 'vue-pluralize'

Vue.use(VuePluralize)

// import VueFriendlyIframe from 'vue-friendly-iframe';
// Vue.use(VueFriendlyIframe)

import VueMq from 'vue-mq'

Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: 540,
        md: 720,
        lg: 960,
        xl: 1140,
    },
    defaultBreakpoint: 'sm' // customize this for SSR
})

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyCQykJzn55jGvz8sx7BdhAE_C18Voj_piU', libraries: 'places' } })

Utils.registerComponents()

Utils.addCustomMixin('api')
Utils.addCustomMixin('user')
Utils.addCustomMixin('toast')

Vue.config.productionTip = false

import { store } from '@/store'
import Utils from '@/providers/Utils'
import api from '@/providers/Api'
import user from '@/User'

Utils.addAuthorizationInterceptor(store, router, user)

const app = new Vue({
    el: '#root-app',
    store,
    router,
    api,
    user,
    methods: {
        isEmpty (obj) {
            return _.isEmpty(obj)
        },
    }
})

// Sentry setup
// Sentry.init({
//     app,
//     dsn: process.env.VUE_APP_SENTRY_DSN,
//     integrations: [new Integrations.BrowserTracing()],
//
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
// })

if (window.Cypress) {
    window.app = app
}

